import BookingListPage from './BookingListPage';
import { withBookingListContext } from './contextProvider/BookingListContextProvider';

const BookingListPageWithContext = withBookingListContext(BookingListPage);
const ConnectBookingListPage = () => <BookingListPageWithContext />;

export default ConnectBookingListPage;
